/* سوق واو: إصلاح تنسيق الأسعار للعملات بثلاث خانات عشرية (مثل الريال العماني) */
export * from './utilities.js';
import { formatMoney as baseFormatMoney } from './utilities.js';
const THREE_DEC = ['OMR','BHD','KWD','JOD','TND','IQD','LYD'];
const re = /\{\{\s*(\w+)\s*\}\}/;
export function formatMoney(cents, format = '') {
  const s = (window.themeHDN && window.themeHDN.settings) || {};
  const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || s.shopCurency;
  if (!THREE_DEC.includes(cur)) return baseFormatMoney(cents, format);
  if (typeof cents === 'string') cents = cents.replace('.', '');
  const n = Number(cents);
  if (isNaN(n)) return '0';
  const parts = (n / 100).toFixed(3).split('.');
  const value = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') + '.' + parts[1];
  const f = (cur === s.shopCurency ? s.moneyFormat : format) || s.moneyFormat || '{{amount}}';
  return f.replace(re, value);
}

/* سوق واو: زر Esc يسكّر النوافذ الجانبية (البحث، السلة، القائمة) */
if (!window.__swEscClose) {
  window.__swEscClose = true;
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    const d = Array.from(document.querySelectorAll('dialog[open]')).pop();
    const b = d && d.querySelector('.hdt-dialog-btn__close');
    if (b) b.click();
  }, true);
}

/* سوق واو: صور أغلفة المقالات ووصفها (alt) بالإنجليزي في النسخة الإنجليزية */
const SW_EN_IMAGES = {
  'articles/blog-oily-serum-v2.jpg': ['files/blog-oily-serum-en.jpg', 'Best Korean serum for oily skin – Sooq Woow Beauty Guide'],
  'articles/blog-korean-v2.jpg': ['files/blog-korean-en.jpg', 'Korean skincare routine step by step – Sooq Woow Beauty Guide'],
  'articles/blog-sunscreen-v2.jpg': ['files/blog-sunscreen-en.jpg', 'Best sunscreen for Oman’s hot, humid weather – Sooq Woow Beauty Guide'],
  'articles/blog-winter-v2.jpg': ['files/blog-winter-en.jpg', 'Winter routine for dry skin – Sooq Woow Beauty Guide'],
  'articles/blog-anua-boj-v2.jpg': ['files/blog-anua-boj-en.jpg', 'Anua or Beauty of Joseon – Sooq Woow Beauty Guide'],
  'articles/blog-nia-vitc-v2.jpg': ['files/blog-nia-vitc-en.jpg', 'Niacinamide and vitamin C – Sooq Woow Beauty Guide'],
  'articles/blog-hair-v2.jpg': ['files/blog-hair-en.jpg', 'Hair care routine for dry and thinning hair – Sooq Woow Beauty Guide'],
  'articles/blog-dry-moisturizer-v2.jpg': ['files/blog-dry-moisturizer-en.jpg', 'Best moisturizer for dry skin in Oman – Sooq Woow Beauty Guide'],
  'articles/blog-dark-spots-v3_7be7e32f-d605-4486-a8ae-484adbb4adf4.jpg': ['files/blog-dark-spots-en.jpg', 'Pigmentation and dark spots routine – Sooq Woow Beauty Guide'],
  'articles/blog-dark-spots-v3.jpg': ['files/blog-dark-spots-en.jpg', 'Pigmentation and dark spots routine – Sooq Woow Beauty Guide']
};
function swSwapEnImages(root) {
  if ((document.documentElement.lang || '').slice(0, 2) !== 'en') return;
  (root || document).querySelectorAll('img, source').forEach(function (el) {
    let hit = null;
    ['src', 'srcset', 'data-src', 'data-srcset'].forEach(function (a) {
      let v = el.getAttribute(a);
      if (!v) return;
      let nv = v;
      for (const k in SW_EN_IMAGES) {
        if (nv.indexOf(k) > -1) { nv = nv.split(k).join(SW_EN_IMAGES[k][0]); hit = SW_EN_IMAGES[k]; }
      }
      if (nv !== v) el.setAttribute(a, nv);
    });
    if (!hit && el.tagName === 'IMG') {
      const cur = el.getAttribute('src') || '';
      for (const k in SW_EN_IMAGES) if (cur.indexOf(SW_EN_IMAGES[k][0]) > -1) hit = SW_EN_IMAGES[k];
    }
    if (hit && el.tagName === 'IMG' && el.getAttribute('alt') !== hit[1]) el.setAttribute('alt', hit[1]);
  });
}
/* سوق واو: نصوص باقية بالعربي في النسخة الإنجليزية */
const SW_EN_TEXT = [
  [/^\s*أجيبي على سؤالين سريعين[\s\S]*$/, 'Answer two quick questions and we’ll recommend a morning and evening routine from our products based on your skin type and needs.']
];
function swFixEnText(root) {
  if ((document.documentElement.lang || '').slice(0, 2) !== 'en' || !document.body) return;
  const w = document.createTreeWalker(root && root.nodeType === 1 ? root : document.body, 4);
  let n;
  while ((n = w.nextNode())) {
    const t = n.nodeValue;
    if (!t || !/[؀-ۿ]/.test(t)) continue;
    for (const [rx, en] of SW_EN_TEXT) if (rx.test(t)) { n.nodeValue = en; break; }
  }
}
if (!window.__swEnImg) {
  window.__swEnImg = true;
  swSwapEnImages();
  document.addEventListener('DOMContentLoaded', function () { swSwapEnImages(); swFixEnText(); });
  window.addEventListener('load', function () { swFixEnText(); setTimeout(swFixEnText, 1500); });
  new MutationObserver(function (m) { m.forEach(function (r) { r.addedNodes.forEach(function (n) { if (n.nodeType === 1) { swSwapEnImages(n); swFixEnText(n); } }); }); }).observe(document.documentElement, { childList: true, subtree: true });
}
